import type { ApiResponse, User } from '@/types/api';

import { api, publicApi } from './api';

interface AuthPayload {
  user: User;
  accessToken?: string;
  refreshToken?: string;
  message?: string;
  requiresEmailVerification?: boolean;
  requiresPhoneVerification?: boolean;
}

export const authService = {
  login: async (data: { email: string; password: string }) => {
    const response = await api.post<ApiResponse<AuthPayload>>('/auth/login', data);
    return response.data.data;
  },
  register: async (data: {
    name: string;
    email: string;
    password: string;
    phone?: string;
  }) => {
    const response = await api.post<ApiResponse<AuthPayload>>('/auth/register', data);
    return response.data.data;
  },
  me: async () => {
    const response = await api.get<ApiResponse<User>>('/auth/me');
    return response.data.data;
  },
  logout: async () => {
    await api.post('/auth/logout');
  },
  demoLogin: async () => {
    const response = await publicApi.post<ApiResponse<AuthPayload>>(
      '/auth/demo',
      {},
      { headers: { 'x-tenant-slug': 'demo' } },
    );
    return response.data.data;
  },
};
